/**
 * Fait fermer un panneau par le bouton RETOUR du navigateur.
 *
 * Une feuille qui se pose par-dessus l'ecran est, pour le joueur, un endroit
 * ou il « est alle » : son reflexe pour en sortir est RETOUR, surtout sur
 * telephone. Or elle ne change pas d'URL, donc RETOUR ne lui faisait rien du
 * tout quand la page etait la premiere de l'historique : la feuille restait la,
 * sans croix visible, et il ne restait plus qu'a modifier l'URL a la main.
 *
 * On ajoute donc une entree d'historique a l'ouverture, et on la retire a la
 * fermeture. L'URL, elle, ne bouge pas : c'est un panneau, pas une page.
 */
import { useEffect, useRef } from 'react';

/** Marque nos propres entrees, pour ne jamais retirer celle de quelqu'un d'autre. */
const MARKER = 'retusch:overlay';

export function useDismissOnBack(open: boolean, close: () => void): void {
  // La fermeture passe par une ref : sans elle, une fonction recreee a chaque
  // rendu relancerait l'effet, donc empilerait une entree d'historique par
  // rendu.
  const closeRef = useRef(close);
  closeRef.current = close;

  useEffect(() => {
    if (!open) return;

    const href = window.location.href;
    window.history.pushState({ [MARKER]: true }, '', href);

    const onPop = (): void => closeRef.current();
    window.addEventListener('popstate', onPop);

    return () => {
      window.removeEventListener('popstate', onPop);
      // Fermeture par un AUTRE chemin (croix, fond, Echap) : notre entree est
      // encore la et il faut la retirer, sinon le prochain RETOUR du joueur ne
      // ferait rien de visible.
      //
      // Deux verrous avant d'y toucher. L'etat, parce qu'une fermeture par
      // RETOUR a deja depile l'entree et qu'un second retour reculerait d'un
      // cran de trop. L'URL, parce que la feuille se ferme aussi quand elle
      // debouche sur un salon : reculer annulerait l'entree dans la partie.
      const state = window.history.state as Record<string, unknown> | null;
      if (window.location.href === href && state?.[MARKER] === true) {
        window.history.back();
      }
    };
  }, [open]);
}
